<div #container class="wfm-date-picker-range">
	<div class="date-picker-outer-container" [class.button-group]="asButton">
		<ng-container *ngIf="!asButton">
			<button
				[attr.aria-controls]="'date-picker--range-' + id"
				aria-haspopup="true"
				type="button"
				class="button button--icon button--icon-transparent date-picker__calendar-icon-container"
			>
				<div class="date-picker__calendar-icon" (click)="isOpen = true" id="date-picker-calendar-icon">
					<svg-icon
						name="ico-calendar-16"
						[svgStyle]="{ 'width.px': 16, 'height.px': 16, fill: 'currentColor' }"
						[ngStyle]="{ height: '16px' }"
					>
					</svg-icon>
				</div>
			</button>
			<input
				type="text"
				id="date-picker-handle-input"
				class="textbox"
        #dateRangePickerInput
				[attr.name]="'date-picker-range-' + id"
				[tooltip]="hoverDataFormat"
				[disableTooltip]="disableUserInput"
				[attr.aria-invalid]="error"
				[placeholder]="(placeholder | translate) || ''"
				[(ngModel)]="input"
				(ngModelChange)="parseInput()"
        (focus)="!disableUserInput && onFocus()"
				(blur)="!disableUserInput && setValue()"
				(keyup.enter)="!disableUserInput && setValue()"
				[class.date-picker-user-input]="disableUserInput"
				[readOnly]="disableUserInput"
				(click)="onUserInputClick()"
			/>
		</ng-container>

		<ng-container *ngIf="asButton">
			<button
				type="button"
				aria-pressed="false"
				class="button no-active u--1/1 flex--right wfm-date-picker-range-button"
				(click)="isOpen = true"
			>
				<span class="flex--item--zero">{{ input || (placeholder | translate) || '' }}</span>
				<div class="date-picker__calendar-icon">
					<svg-icon
						name="ico-calendar-16"
						[svgStyle]="{ 'width.px': 16, 'height.px': 16, fill: 'currentColor' }"
						[ngStyle]="{ height: '16px' }"
					>
					</svg-icon>
				</div>
			</button>
		</ng-container>
	</div>

	<wfm-dropdown
		[(isOpen)]="isOpen"
		[scrollbar]="true"
		[adjustVerticalOverflow]="true"
		dropdownWidth="500px"
		maxWidth="570px"
		(isOutsideMousedown)="outSideDropDown()"
	>
		<div *ngIf="isOpen" class="flex flex--nowrap flex--left flex--stretch flex--col">
			<div *ngIf="!customRangeOnly" class="u-p---">
				<wfm-select-panel
					labelField="label"
					[required]="required"
					[unsetMaxHeight]="true"
					[items]="options"
					[dateRangeOptions]="true"
					[(value)]="selectedOption"
					(valueChange)="selectedOptionChange()"
				>
				</wfm-select-panel>
			</div>

			<div *ngIf="isCustomRange" class="u-p---">
				<wfm-date-picker
					[format]="format"
					[placeholder]="placeholder"
					[formatDelimiter]="formatDelimiter"
					[autoWidth]="false"
					[firstDayOfWeek]="firstDayOfWeek"
					[min]="min"
					[max]="max"
					[rangeMode]="true"
					[inline]="true"
					[(startValue)]="startValue"
					[(endValue)]="endValue"
					(errorChange)="error = $event"
					(startErrorChange)="startError = $event"
					(endErrorChange)="endError = $event"
				></wfm-date-picker>

				<!-- buttons -->
				<div class="flex flex--row flex--nowrap flex--stretch flex--right">
					<div class="u-p---">
						<button tabindex="3" type="button" class="button button--tertiary" (click)="reset()">
							<span>{{ 'core.label.reset' | translate }}</span>
						</button>
					</div>
					<div class="u-p---">
						<button tabindex="4" type="button" class="button"
                    (click)="apply()" [disabled]="startError || endError || !(startValue && startValue.isValid() && endValue && endValue.isValid())">
							<span>{{ 'core.label.apply' | translate }}</span>
						</button>
					</div>
				</div>
			</div>
		</div>
	</wfm-dropdown>
</div>
